var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { Accordion, AccordionItem, Typography } from "@bolteu/kalep-react";
import { cx } from "../../utils/cx";
import { AccordionTableColumnHeader } from "./AccordionTableColumnHeader";
import { AccordionTableContent, AccordionTableContentSeparator } from "./AccordionTableContent";
import { AccordionTableInlineActions } from "./AccordionTableInlineActions";
import { AccordionTableSkeleton } from "./AccordionTableSkeleton";
export function AccordionTable(_a) {
    var { items, getItemHeader = getItemHeaderDefault, columns, isLoading, loadingSkeletonRowCount, inlineActions, paddingStart, paddingEnd } = _a, rest = __rest(_a, ["items", "getItemHeader", "columns", "isLoading", "loadingSkeletonRowCount", "inlineActions", "paddingStart", "paddingEnd"]);
    if (isLoading) {
        return (React.createElement(AccordionTableSkeleton, { paddingStart: paddingStart, paddingEnd: paddingEnd, loadingSkeletonRowCount: loadingSkeletonRowCount }));
    }
    return (React.createElement(Accordion, Object.assign({ paddingStart: paddingStart, paddingEnd: paddingEnd }, rest), items.map((item) => {
        const accordionHeader = getItemHeader(item);
        return (React.createElement(AccordionItem, { key: item.id, id: item.id, title: accordionHeader },
            React.createElement("ul", { className: cx("list-none flex flex-col m-0 p-0 gap-4") },
                Object.entries(columns).map(([key, column]) => {
                    const { label, tooltip, tooltipProps, direction = "vertical", alignItems, justify, renderCell = renderCellDefault, } = column;
                    const hasLastBaselineAlignment = direction === "horizontal" && (alignItems === "last baseline" || !alignItems);
                    return (React.createElement("li", { key: `${item.id}-${key}` },
                        React.createElement(AccordionTableContent, { direction: direction, alignItems: alignItems, justify: justify },
                            label ? (React.createElement(AccordionTableColumnHeader, { tooltip: tooltip, tooltipProps: tooltipProps }, label)) : null,
                            hasLastBaselineAlignment ? React.createElement(AccordionTableContentSeparator, null) : null,
                            renderCell(item, key))));
                }),
                inlineActions && inlineActions.length > 0 ? (React.createElement("li", { key: `${item.id}-accordion-table-inline-actions-row` },
                    React.createElement(AccordionTableInlineActions, { item: item, actions: inlineActions }))) : null)));
    })));
}
function getItemHeaderDefault(item) {
    return {
        primary: item.id,
    };
}
function renderCellDefault(item, columnKey) {
    return React.createElement(Typography, null, item[columnKey]);
}
